// extracted by mini-css-extract-plugin
export default {"successColor":"#21812d"};